import { rest } from "msw"
import { delay } from "../../../utils"

export const pickUpPoints = [
  rest.get("*/v1/stores/:storeID/pick-up-points/", function(_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./get.fixture.json")))
  }),
]
